import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import { useEffect, useState } from "react";

export interface SAMLMetadataDialogProps {
    value?: SAMLSetupUrl | SAMLSetupXml
    open: boolean
    onSave: (v: SAMLSetupUrl | SAMLSetupXml) => void
    onClose: () => void
}

export interface SAMLSetupUrl {
    type: "url",
    url: string
}

export interface SAMLSetupXml {
    type: "xml"
    metadata: string
}

export function SAMLMetadataDialog(props: SAMLMetadataDialogProps) {
    const [mode, setMode] = useState<"url" | "xml">("url");
    const [value, setValue] = useState("");

    useEffect(() => {
        //nothing configured: start from the empty URL form rather than whatever
        //the last open left behind. The dialog's caller stays mounted, so
        //without this an abandoned edit survives a Close and reappears.
        if (!props.value) {
            setMode("url");
            setValue("");
            return;
        }

        setMode(props.value.type);

        if (props.value.type === "url") {
            setValue(props.value.url);
        } else if (props.value.type === "xml") {
            setValue(props.value.metadata);
        }
    }, [props.value, props.open]);

    return <Dialog
        open={props.open}
    >
        <DialogTitle>
            {"SAML IDp Metadata"}
        </DialogTitle>
        <DialogContent sx={{ minWidth: "400px" }}>
            {mode === "url" && <>
                <TextField
                    id="idp-url"
                    label="URL to fetch IDp metadata"
                    value={value}
                    sx={{ marginTop: "10px", marginBottom: "20px" }}
                    fullWidth
                    onChange={(x) => setValue(x.target.value)}
                />
            </>}
            {mode === "xml" && <>
                <TextField
                    sx={{
                        marginTop: "10px"
                    }}
                    inputProps={{
                        style: {
                            whiteSpace: "nowrap"
                        }
                    }}

                    id="idp-metadata"
                    label="IDp Metadata"
                    multiline
                    rows={10}
                    placeholder="IDp Metadata"
                    value={value}
                    fullWidth

                    onChange={(x) => setValue(x.target.value)}
                />
            </>}
        </DialogContent>
        <DialogActions>
            {mode === "url" && <>
                <Button id="saml-mode-metadata" onClick={() => {
                    setValue("");
                    setMode("xml");
                }} variant="outlined">
                    Paste XML
                </Button>
            </>}
            {mode === "xml" && <>
                <Button id="saml-mode-url" onClick={() => {
                    setValue("");
                    setMode("url");
                }} variant="outlined">
                    Fetch from URL
                </Button>
            </>}
            <Button id="cancel-saml-metadata-dialog" onClick={() => {
                props.onClose();
            }} variant="outlined">
                Close
            </Button>
            <Button id="save-saml-metadata-dialog" onClick={() => {
                if (mode === "url") {
                    props.onSave({
                        type: "url",
                        url: value,
                    });
                } else {
                    props.onSave({
                        type: "xml",
                        metadata: value,
                    });
                }
            }} variant="contained" autoFocus>
                Save
            </Button>
        </DialogActions>
    </Dialog>;
}

export default SAMLMetadataDialog;
